import { render, staticRenderFns } from "./ClientNameFilter.vue?vue&type=template&id=2a510c19&"
import script from "./ClientNameFilter.vue?vue&type=script&lang=ts&"
export * from "./ClientNameFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports